import { Box, Typography } from "@mui/material";
import dayjs from "dayjs";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { currencyFormatter } from "../../../../../utils/Formatter";

type Props = {
  data: any;
};

const InsuranceDetails = ({ data }: Props) => {
  return (
    <>
      {data?.insurerName ? (
        <Box sx={{ display: "flex" }}>
          <Box>
            <Typography className="label-header-text">Insurer</Typography>
            <Typography>{data?.insurerName}</Typography>
          </Box>
          <Box>
            <Typography className="label-header-text">
              Policy Amount*
            </Typography>
            <Typography>
              {data?.policyAmount
                ? `$${currencyFormatter(data?.policyAmount)}`
                : "-"}
            </Typography>
          </Box>
          <Box>
            <Typography className="label-header-text">
              Expiration Date*
            </Typography>
            <Typography>
              {data?.expiryDate
                ? dayjs(data?.expiryDate).format("MM/DD/YYYY")
                : " "}
            </Typography>
          </Box>
          <Box>
            <Typography className="label-header-text">
              Copy of Policy*
            </Typography>
            <Typography>
              {data?.policyDocumentKey && data?.policyDocumentName !== "" ? (
                <CheckCircleOutlineIcon color="success" />
              ) : (
                <HighlightOffIcon color="error" />
              )}
            </Typography>
          </Box>
        </Box>
      ) : (
        <>-</>
      )}
    </>
  );
};

export default InsuranceDetails;
